import { Rectangle } from "pixi.js";
import type { RefObject } from "react";
import { useEffect } from "react";
import type { ManagedDisplayObject } from "../types";
import { useScene } from "./useScene";

export interface VisibilityWhenFitsOptions {
    paddingRatio?: number;
    fadeStartPaddingRatio?: number;
    fade?: boolean;
}

export function useVisibilityWhenFits(
    ref: RefObject<ManagedDisplayObject | null>,
    bounds: Rectangle,
    {
        paddingRatio = 0.05,
        fadeStartPaddingRatio = 0,
        fade = true,
    }: VisibilityWhenFitsOptions = {},
): void {
    const { viewportEffectsManager } = useScene();

    useEffect(() => {
        if (!ref.current) return;

        if (!(bounds instanceof Rectangle)) {
            console.warn(
                "[useVisibilityWhenFits] Expected bounds to be a PIXI.Rectangle. Received:",
                bounds,
            );
            return;
        }

        return viewportEffectsManager.registerVisibilityWhenFits(
            ref,
            bounds,
            paddingRatio,
            fadeStartPaddingRatio,
            fade,
        );
    }, [
        bounds,
        fade,
        fadeStartPaddingRatio,
        paddingRatio,
        ref,
        viewportEffectsManager,
    ]);
}
